import { render, staticRenderFns } from "./accessibility-page.vue?vue&type=template&id=736905c4&"
import script from "./accessibility-page.vue?vue&type=script&lang=js&"
export * from "./accessibility-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports